import { useRoute } from 'vue-router';
import { defineNuxtPlugin } from '#app';
import { nextTick, watch } from 'vue';
import { storeToRefs } from 'pinia';
import useGetItToday from '~/composables/useGetItToday';
import { useDeliveryAndPickupStore } from '../store/deliveryAndPickupStore';
import { useStoreUtils } from '../composables/useStoreUtils';
import { GetItCopy } from '../types/delivery-pickup-info';
import { DELIVERY_AND_PICKUP_V2 } from '../constants/delivery-and-pickup';

export const AUTO_SELECT_TODAY = 'autoSelectGetItToday';

export default defineNuxtPlugin((nuxtApp) => {
  const { isGetItTodayEnabled } = useGetItToday();

  if (!isGetItTodayEnabled.value) {
    return;
  }

  const { replaceSelectedValues, triggerSelectedFacetsUpdate } = useStoreUtils();
  const store = useDeliveryAndPickupStore();
  const { afterStoreInit } = store;

  const { storeLocation, shipFromLocation, bopsEligible } = storeToRefs(store);

  const route = useRoute();
  const isMounted = ref(false);
  const isStoreReady = ref(false);
  const isFFMounted = ref(false); // needs to avoid hydration issue

  const updateDeliveryUrl = () => {
    const selectedValues: string[] = [];

    if (bopsEligible.value && storeLocation.value) {
      selectedValues.push(`BOPS=${storeLocation.value}`);
    }

    if (shipFromLocation.value) {
      selectedValues.push(`SDD=${shipFromLocation.value}`);
    }

    if (selectedValues.length > 0) {
      nextTick(() => {
        replaceSelectedValues({
          name: GetItCopy.getItToday,
          displayName: DELIVERY_AND_PICKUP_V2,
          selectedValues,
        });
        triggerSelectedFacetsUpdate(); // update url
      });
    }
  };

  nuxtApp.hook('app:mounted', () => {
    isMounted.value = true;
  });

  if (route.query[AUTO_SELECT_TODAY] === 'true') {
    afterStoreInit(() => {
      isStoreReady.value = true;
    });

    const uns = watch([isStoreReady, isFFMounted, isMounted], ([storeReady, ffMounted, appMounted]) => {
      if (storeReady && ffMounted && appMounted) {
        updateDeliveryUrl();
        uns();
      }
    });
  }

  return {
    provide: {
      markFacetsMounted: () => {
        isFFMounted.value = true;
      },
    },
  };
});
